import { Message } from 'element-ui';
import { queryDictionary } from '@/service';
/**
 * state(类似存储全局变量的数据)
 * getters(提供用来获取state数据的方法)
 * actions(提供跟后台接口打交道的方法， 并调用mutations提供的方法)
 * mutations(提供存储设置state数据的方法)
 */
let state = {
  screen_type: [], //屏幕类型
  coupon_platform: [],//营销中心--优惠券归属平台
  coupon_type: [],//营销中心--优惠券类型
  coupon_background_color: [],//营销中心--优惠券背景颜色
  coupon_status:[],//营销中心--优惠券批次状态
  coupon_code_status:[]//营销中心--优惠券状态
}
let getters = {
  screenTypes: state => state.screen_type,
  screenTypesConfig: state => {
    let arr = [{ label: '不限', value: -1, }];
    if (state.screen_type && state.screen_type.length) {
      arr[1] = state.screen_type;
    }
    return arr;
  },
  couponPlatforms: state => state.coupon_platform,
  couponTypes: state => state.coupon_type,
  couponBgColor: state => state.coupon_background_color,
  couponStatus:state => state.coupon_status,
  couponCodeStatus:state=>state.coupon_code_status
}
let mutations = {
  set_screen_type(state, { dictType, data }) {
    state[dictType] = data;
    sessionStorage.setItem(`$${dictType}`, JSON.stringify(data));
  },
  set_coupon_platform(state, { dictType, data }) {
    state[dictType] = data;
    sessionStorage.setItem(`$${dictType}`, JSON.stringify(data));
  },
  set_coupon_type(state, { dictType, data }) {
    state[dictType] = data;
    sessionStorage.setItem(`$${dictType}`, JSON.stringify(data));
  },
  set_coupon_background_color(state, { dictType, data }) {
    state[dictType] = data;
    sessionStorage.setItem(`$${dictType}`, JSON.stringify(data));
  },
  set_coupon_status(state, { dictType, data }) {
    state[dictType] = data;
    sessionStorage.setItem(`$${dictType}`, JSON.stringify(data));
  },
  set_coupon_code_status(state, { dictType, data }) {
    state[dictType] = data;
    sessionStorage.setItem(`$${dictType}`, JSON.stringify(data));
  }
}
let actions = {
  getDictionaryAsync(context, dictType) {
    const val = JSON.parse(sessionStorage.getItem(`$${dictType}`)) || [];
    if (val && val.length) {
      context.commit(`set_${dictType}`, {
        dictType,
        data: val,
      });
      return false;
    }
    queryDictionary({ dictType }).then((res) => {
      // console.log(res);
      if (res.code != 200) {
        Message({
          showClose: true,
          message: res.message,
          type: 'error',
          duration: 2 * 1000
        })
        return;
      }
      context.commit(`set_${dictType}`, {
        dictType,
        data: res.data,
      });
    });
  },
}
export default {
  namespaced: true, // namespaced 属性，限定命名空间
  state,
  getters,
  mutations,
  actions
}